<!--TITLE-->
<div class="container-fluid pt-120 pb-5">
    <div class="row title-bar">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1 class="text-uppercase text-center">Our <span class="text-yellow">Plumbing</span> Services</h1>
                        <p class="text-center pt-3">Eazy Breezy Heating and Cooling is ready to repair, replace, or maintain your source of domestic hot water. We are prepared to work all budgets and comfort levels to provbide the optimal delivery of hot water to all parts of your home!</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--15 YEARS XP BAR-->
<div class="container-fluid">
    <div class="row xp-bar bg-red">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-sm-9">
                        <h2 class="text-white text-center">Over 15 Years of Experience</h2>
                        <p class="text-white text-justify pt-3">Trust Eazy Breezy to service your plumbing when it fails you. We pride ourselves on our strong service background and customer satisfaction!</p>
                    </div>
                    <div class="col-sm-3 text-center mobile-pt">
                        <i class="fa fa-regular fa-gem"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--SERVICES-->
<div class="container-fluid">
    <div class="row">
        <div class="col-lg-6 service-col pb-5">
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-yellow icon-install"></div></div>
                        <div class="service-text">
                            <h1>Plumbing Installation</h1>
                            <h3>Hot Water Tanks</h3>
                            <p class="pt-3">At eazy Breezy, we can supply and install any make or model of hot water tank. Whether you would like a 40 gallon atmospheric tank to fit your budget, or a tankless hot water heater to keep up with your consumption, we have you covered. You may wonder, "Is a tankless hot water heater right for my family?"</p>
                            <p class="pt-3">What Are The Benefits of a Tankless Water Heater?</p>
                            <ol>
                                <li><span class="text-bold">More energy efficient.</span><br>A tankless water heater can conserve 27 to 50 percent more energy than a traditional model.</li>
                                <li><span class="text-bold">Longer life span.</span><br>On average, tankless water heaters last 5 - 10 years longer than tank water heaters.</li>
                                <li><span class="text-bold">Plenty of hot water.</span><br>A tankless water heater heats up your water non-stop as needed.</li>
                                <li><span class="text-bold">Saves space.</span><br>A tankless hot water heater mounts on your walland is normally 28" tall x 20" wide and just 10" deep.</li>
                            </ol>
                            <h3>General</h3>
                            <p class="pt-3">Whether you require a toilet installed, faucet replaced or a whole house plumbing rough-in, Eazy Breezy is your one stop shop. Our Red Seal plumbers would be happy to supply a quote on any size plumbing job. There is no job too big or small!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-yellow icon-maintenance"></div></div>
                        <div class="service-text">
                            <h1>Plumbing Maintenance</h1>
                            <p class="pt-3">We all need water in our homes, but the last thing anyone wants is a leak or a drain backup in their home! Let Eazy Breezy help you avoid this situation when possible by regular maintenance checks. Hot water heaters, especially tankless models, require regular maintenece in order to maxamize their lifespan.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="service-item pt-25 pt-0-360">
                        <div class="service-icon i-circle mr-3 desktop-center-icon"><div class="icon-sprite icon-yellow icon-repair"></div></div>
                        <div class="service-text">
                            <h1>Plumbing Repair</h1>
                            <p class="pt-3">Eazy Breezy is ready to help with any plumbing repairs and replacements needed in your home. Whether you need a new toilet installed or a leaky faucet repaired, our Red Seal plumbers are ready and able to assist with any water supply or drainage issues in your house or business.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-6 contact-img">
            &nbsp;
        </div>
    </div>
</div>

<!--BOOK AND PHONE BAR-->
<div class="container-fluid">
    <div class="row phone-bar bg-blue">
        <div class="col-12">
            <div class="container">
                <div class="row">
                    <div class="col-sm-4 border-r pb-mobile-20">
                        <h3 class="text-uppercase text-center lh-20 fw-400 text-red">Office</h3>
                        <p class="text-center text-white">587.596.3040</p>
                    </div>
                    <div class="col-sm-4 d-flex justify-content-center border-r pb-mobile-20">
                        <div class="action-button verticle-center-text" routerLink="/contact" href="/contact">
                            <span>BOOK ONLINE</span>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <h3 class="text-uppercase text-center lh-20 fw-400 text-red">Dispatch</h3>
                        <p class="text-center text-white">780.964.3299</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--OTHER SERVICES-->
<div class="container-fluid pt-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="text-center text-uppercase">Other Services</h1>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-sm-6">
                <div class="card transparent-card">
                    <div class="card-header d-flex justify-content-center">
                        <div class="i-circle">
                            <i class="text-red fa fa-solid fa-fire"></i>
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <h2>Heating</h2>
                        <p class="pt-2">Since Edmonton is known for its cooler climate, our heating experts will help you maximize the comfort level of your home even through our sub-zero winters.<br><a rel="/heating" href="/heating" class="text-red">Read more.</a></p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="card transparent-card">
                    <div class="card-header d-flex justify-content-center">
                        <div class="i-circle rounded-circle">
                            <i class="text-blue fa fa-solid fa-snowflake"></i>
                        </div>
                    </div>
                    <div class="card-body text-center">
                        <h2>Cooling</h2>
                        <p class="pt-2">Edmonton weather is changing and the need to have climate control through these hot summer months is a must. Our cooling experts will help you beat the heat.<br><a rel="/cooling" href="/cooling" class="text-blue">Read more.</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>